import typeMap from './fields/typeMap';
import {FieldTemplate} from './models/JsonTypes';
import Field from './fields/Field';

let uniqueIncrement = 0;

export default function (config: FieldTemplate, wasDuplicated = false) {
    // A unique value for each field in the UI, to assign Mithril keys
    // It doesn't have to be the same on subsequent page loads
    if (!config.unique || wasDuplicated) {
        config.unique = ++uniqueIncrement + '';
    }

    if (wasDuplicated) {
        // Remove key so the backend can generate a new unique ID
        delete config.key;
    }

    const field: Field = new typeMap[config.type]({});

    const whitelisted = ['unique', 'type', 'cannotFill', 'contentHtml'].concat(field.whiteListConfigProperties());

    // Remove keys that might have persisted from a previous field type
    (Object.keys(config) as (keyof FieldTemplate)[]).forEach((key) => {
        if (whitelisted.indexOf(key) === -1) {
            delete config[key];
        }
    });

    if (config.type === 'items') {
        if (!Array.isArray(config.fields)) {
            config.fields = [];
        }

        if (config.fields.length === 0) {
            config.fields.push({
                type: 'short',
            });
        }
    }

    if (config.type === 'upload') {
        if (!config.mime) {
            config.mime = 'image/*';
        }
    }
}
